import { render, staticRenderFns } from "./PatientDetailPage.vue?vue&type=template&id=1209e3da&scoped=true&"
import script from "./PatientDetailPage.vue?vue&type=script&lang=js&"
export * from "./PatientDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./PatientDetailPage.vue?vue&type=style&index=0&id=1209e3da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1209e3da",
  null
  
)

export default component.exports